import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import styles from './ElevationBlock.scss'
import { Block } from 'features/ride_reports/EditPage/ReportEditor/Block'
import { removeBlock } from 'lib/blockUtils'
import { EditorState } from 'draft-js'
import { showModal } from 'lib/modalUtils'
import { experienceRoutesSelectors } from 'lib/api/experiences/routes'
import { INSERT_ELEVATION_PROFILE_MODAL } from 'common/modals/InsertElevationProfileModal'
import cx from 'classnames'

export class _ElevationBlock extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      imageVersion: 1 // add to querystring to bust browser cache on image update
    }
  }

  componentDidUpdate (prevProps) {
    const { blockProps, block } = this.props
    const { isSelected } = blockProps
    if (!isSelected && !block.getData().get('routeId')) {
      this.removeSelf()
    }
  }

  saveElevationProfile = ({ routeId }) => {
    this.props.blockProps.onChange({ routeId })
  }

  removeSelf = () => {
    const { blockProps: { getEditorState, setEditorState }, block } = this.props
    const contentState = getEditorState().getCurrentContent()
    setEditorState(EditorState.push(getEditorState(), removeBlock(contentState, block.getKey()), 'remove-range'))
  }

  showInsertModal = () => {
    const { block, routes } = this.props
    const data = block.getData()
    const routeId = data.get('routeId', null)

    showModal(INSERT_ELEVATION_PROFILE_MODAL, {
      saveElevationProfile: this.saveElevationProfile,
      routes,
      routeId,
      maybeRemoveSelf: () => {
        if (!block.getData().get('routeId', null)) {
          this.removeSelf()
        }
      }
    })
  }

  render () {
    const { blockProps, block, routes } = this.props
    const { imageVersion } = this.state
    const { isSelected } = blockProps
    const data = block.getData()
    const routeId = data.get('routeId', null)

    const profileSrc = routeId ? `/routes/elevation_profile/${routeId}.png?${imageVersion}` : null

    const routeRemoved = routeId && !routes.find(r => r.id === routeId)
    if (isSelected && !routeId) {
      this.showInsertModal()
    }

    return (
      <Block size='bigBlock' blockProps={blockProps} block={block} grabFocusOnUpdate={false}>
        <div className={styles.children}>
          {routeRemoved
            ? <div className={cx(styles.selected, styles.empty)}>
              Whoops, it looks like the route for this elevation profile has been removed from the experience!
              {isSelected && <div className={styles.actions}>
                <a onClick={() => this.removeSelf()}>Delete</a>
              </div>}
            </div>
            : <div className={styles.contents}>
              {profileSrc &&
                <Fragment>
                  <img src={profileSrc} />
                  {isSelected && <div className={styles.actions}>
                    <a onClick={() => this.showInsertModal()}>Edit</a>
                    <a onClick={() => this.removeSelf()}>Delete</a>
                  </div>}
                </Fragment>}
            </div>}
        </div>
      </Block>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { experienceId } = ownProps.blockProps.guide

  return {
    routes: experienceRoutesSelectors.routesForExperience(state.routes, experienceId)
  }
}

export const ElevationBlock = connect(
  mapStateToProps,
  null
)(_ElevationBlock)
